import React from 'react'
import './styles'

# "Disputed" indicator for a ticket on the admin ticket lists.
export default DisputedLabel = ->
  <span className="DisputedLabel">Disputed</span>
